import { render, staticRenderFns } from "./ContactDetailsPerson.vue?vue&type=template&id=7ddb15a4&scoped=true&"
import script from "./ContactDetailsPerson.vue?vue&type=script&lang=js&"
export * from "./ContactDetailsPerson.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetailsPerson.vue?vue&type=style&index=0&id=7ddb15a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddb15a4",
  null
  
)

export default component.exports